import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CardContent,
  Typography,
  Grid,
  TextField,
  useMediaQuery,
  Alert,
} from "@mui/material";
import { useTheme } from "@mui/system";
import { DatePicker } from "@mui/x-date-pickers";
import { ExpandMore } from "@mui/icons-material";
import { Card } from "../style";
import { useEffect, useRef, useState } from "react";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { veicoloFields } from "../../rcAutoDetails2/constants";
import CustomSelect from "../../../components/CustomSelect";
import { CustomSelectMenuProps } from "../../../../constants";
import DynamicTable from "../../rcAutoDetails2/dynamicTable";
import ComplexTable from "../../rcAutoDetails2/complexTable";
import { useFormRCAutoDetails } from "../rcautoContext";
import { validateTarga } from "../../rcAuto/nuovoPreventivo/helpers";

function AccordionSection({ children, title, defaultExpanded = false }) {
  return (
    <Accordion defaultExpanded={defaultExpanded}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h5">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
}

const Spacer = styled.div(spacing);

export const formatDate = (date) => {
  if (!date) return "";
  if (typeof date === "string" && date.includes("/")) return date;
  // Accepts Date object or ISO string
  const d = new Date(date);
  if (isNaN(d)) return "";
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

function Veicolo({ dataset, ed, isSaved, disabledFields, errori }) {
  const { formState, dispatch } = useFormRCAutoDetails();
  const [initialDates, setInitialDates] = useState({});
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const Attestato = dataset["Attestato"];
  const Sinistri = dataset["sinistri"];
  const Veicolo = dataset["Veicolo"][0];
  const Propieta = dataset["Proprietà"];
  const Coperture = dataset["Coperture"];
  const statoAss = dataset.idStatoAssicurativo;
  const descrStatoAss = dataset.statoAssicurativoDesc;
  const situaAss = errori.filter((el) => el.codiceErrore === 1);
  const gestioneErroreArray = situaAss[0]?.gestioneErrore?.map((item) => ({
    value: item.idGestioneErrore,
    label: item.gestioneErrore,
  }));

  const getSelectOptions = (field) => {
    if (field.name === "tipoVeicolo") {
      if (!Veicolo.tipoVeicolo) return [];
      return Veicolo.tipoVeicolo.dataset;
    } else if (field.name === "uso") {
      if (!Veicolo.uso) return [];
      return Veicolo.uso.dataset;
    } else if (field.name === "alimentazione") {
      if (!Veicolo.alimentazione) return [];
      return Veicolo.alimentazione.dataset;
    } else if (field.name === "tariffa") {
      if (!Veicolo.tariffa) return [];
      return Veicolo.tariffa.dataset;
    }
    return [];
  };

  useEffect(() => {
    // Save initial date values for disabling logic
    const dateFields = veicoloFields
      .filter((f) => f.type === "date")
      .map((f) => f.name);
    const initial = {};
    dateFields.forEach((name) => {
      initial[name] = Veicolo[name] || "";
    });
    setInitialDates(initial);
  }, []);

  const handleChangeVeicolo = (fieldName, value) => {
    const field = veicoloFields.find((f) => f.name === fieldName);
    let newValue = value;

    if (field && field.type === "date") {
      newValue = formatDate(value);
    }

    // copia errori esistenti
    const newErrors = { ...formState.errors.Veicolo };

    if (field.required && (!newValue || newValue === "")) {
      newErrors[fieldName] = "Campo obbligatorio";
    } else {
      delete newErrors[fieldName];
    }

    // aggiorno errori nel global state
    dispatch({
      type: "set_errors",
      scope: "Veicolo",
      payload: newErrors,
    });

    // aggiorno il valore
    dispatch({
      type: "UPDATE_VEICOLO_FIELD",
      payload: { field: fieldName, value: newValue },
    });
  };

  const parseDate = (dateString) => {
    if (!dateString) return null;
    const [day, month, year] = dateString.split("/");
    return new Date(year, month - 1, day);
  };

  const getFieldDisabled = (field) => {
    if (field === "targa") {
      if (disabledFields.includes(field)) {
        return true;
      }
    }
    if (ed === 1) return false;
    if (ed === 2 && isSaved) return true;
    // In edit mode 2, before save:
    // Only fields that were not empty at mount are disabled; fields that were empty at mount are editable until save
    if (ed === 2) {
      if (!disabledFields.includes(field)) {
        return false; // editable until save
      } else {
        return true; // was not empty at mount, so always disabled
      }
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box display="flex" flexDirection="column" mb={4}>
        {statoAss === -1 ? (
          <Card>
            <CardContent>
              <Typography variant="h5" mt={2} ml={2} mb={4}>
                Stato Assicurativo
              </Typography>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  <CustomSelect
                    error={Boolean(
                      formState.statoAssicurativo.idStatoAssicurativo === ""
                    )}
                    helperText={
                      formState.statoAssicurativo.idStatoAssicurativo === ""
                        ? "Gestione Errore non può essere vuoto"
                        : ""
                    }
                    label="Gestione Errore"
                    options={gestioneErroreArray}
                    value={formState.statoAssicurativo.idStatoAssicurativo}
                    onChange={(e) =>
                      dispatch({
                        type: "set_statoAssicurativo",
                        name: "idStatoAssicurativo",
                        payload: e.target.value,
                      })
                    }
                  />
                </Grid>
                {(formState.statoAssicurativo.idStatoAssicurativo === 3 ||
                  formState.statoAssicurativo.idStatoAssicurativo === 2) && (
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Targa"
                      value={formState.statoAssicurativo.targa}
                      onChange={(e) =>
                        dispatch({
                          type: "set_statoAssicurativo",
                          name: "targa",
                          payload: e.target.value.toUpperCase(),
                        })
                      }
                      error={!validateTarga(formState.statoAssicurativo.targa)}
                      helperText={
                        validateTarga(formState.statoAssicurativo.targa) ===
                        false
                          ? "Targa non valida"
                          : ""
                      }
                    />
                  </Grid>
                )}
              </Grid>
            </CardContent>
          </Card>
        ) : (
          <Alert
            severity="success"
            variant="filled"
            sx={{
              color: theme.palette.mode === "dark" && "white",
              fontSize: 16,
            }}
          >
            {descrStatoAss}
          </Alert>
        )}
      </Box>

      <Card mb={4}>
        <CardContent>
          <AccordionSection title={"Generale"} defaultExpanded={true}>
            <Grid container spacing={3}>
              {veicoloFields.map((field) => {
                const isDisabled = getFieldDisabled(field.name);

                return (
                  <Grid item xs={12} sm={4} key={field.name}>
                    {field.type === "text" &&
                      (["assicurazioneProvenienza", "classeMerito"].includes(
                        field.name
                      ) &&
                      (statoAss === 1 ||
                        statoAss === 2 ||
                        statoAss === 3 ||
                        statoAss === -1) ? (
                        <TextField
                          disabled={true}
                          label={field.label}
                          name={field.name}
                          value={formState.veicolo?.[field.name] || ""}
                          fullWidth
                        />
                      ) : (
                        <TextField
                          disabled={isDisabled}
                          error={Boolean(
                            formState.errors.Veicolo?.[field.name]
                          )}
                          helperText={
                            formState.errors.Veicolo?.[field.name] ?? ""
                          }
                          label={field.label}
                          name={field.name}
                          value={formState.veicolo?.[field.name] || ""}
                          onChange={(e) =>
                            handleChangeVeicolo(field.name, e.target.value)
                          }
                          fullWidth
                          required={field.required}
                        />
                      ))}
                    {field.type === "select" &&
                      (["tariffa"].includes(field.name) &&
                      (statoAss === 1 ||
                        statoAss === 2 ||
                        statoAss === 3 ||
                        statoAss === -1) ? (
                        <CustomSelect
                          disabled={true}
                          label={field.label}
                          name={field.name}
                          value={""}
                          options={getSelectOptions(field)}
                          fullWidth
                          MenuProps={CustomSelectMenuProps}
                        />
                      ) : (
                        <CustomSelect
                          disabled={isDisabled}
                          label={field.label}
                          name={field.name}
                          value={formState.veicolo?.[field.name].value || ""}
                          onChange={(e) =>
                            handleChangeVeicolo(field.name, e.target.value)
                          }
                          error={!!formState.errors.Veicolo?.[field.name]}
                          helperText={formState.errors.Veicolo?.[field.name]}
                          options={getSelectOptions(field)}
                          fullWidth
                          MenuProps={CustomSelectMenuProps}
                          required={field.required}
                        />
                      ))}
                    {field.type === "date" &&
                      ([
                        "dataInizioCopertura",
                        "dataFineCopertura",
                        "dataMora",
                      ].includes(field.name) &&
                      (statoAss === 1 ||
                        statoAss === 2 ||
                        statoAss === 3 ||
                        statoAss === -1) ? (
                        // Special 3 fields
                        <DatePicker
                          label={field.label}
                          value={null} // force empty
                          inputFormat="dd/MM/yyyy"
                          disabled // always disabled
                          onChange={() => {}} // ignore changes
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              error={false} // never error
                              helperText="" // no helper
                              required={false} // not required anymore
                            />
                          )}
                          disableFuture
                          openTo="year"
                          views={["year", "month", "day"]}
                        />
                      ) : (
                        // Normal behavior for other date fields
                        <DatePicker
                          label={field.label}
                          value={
                            formState.veicolo?.[field.name]
                              ? parseDate(formState.veicolo?.[field.name])
                              : null
                          }
                          inputFormat="dd/MM/yyyy"
                          disabled={Boolean(
                            ed === 2 &&
                              (isSaved ||
                                (initialDates[field.name] &&
                                  initialDates[field.name] !== ""))
                          )}
                          onChange={(date) =>
                            handleChangeVeicolo(field.name, date)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              error={Boolean(
                                formState.errors.Veicolo?.[field.name]
                              )}
                              helperText={
                                formState.errors.Veicolo?.[field.name] ?? ""
                              }
                              required={field.required}
                            />
                          )}
                          disableFuture
                          openTo="year"
                          views={["year", "month", "day"]}
                        />
                      ))}
                  </Grid>
                );
              })}
            </Grid>
          </AccordionSection>
        </CardContent>
      </Card>

      <Card mb={4}>
        <CardContent
          sx={{
            maxWidth: isMobile ? "calc(100vw - 40px)" : "100%",
            overflow: "auto",
          }}
        >
          <AccordionSection title={"Attestato"} defaultExpanded={true}>
            {Attestato && (
              <DynamicTable name={"Attestato"} dataset={Attestato} />
            )}
            <Spacer mb={6} />
            {Sinistri && (
              <Typography variant="h5" mb={6}>
                Sinistri
              </Typography>
            )}
            {Sinistri && <ComplexTable dataset={Sinistri} />}
          </AccordionSection>
        </CardContent>
      </Card>

      <Card mb={4}>
        <CardContent
          sx={{
            maxWidth: isMobile ? "calc(100vw - 40px)" : "100%",
            overflow: "auto",
          }}
        >
          <AccordionSection title={"Proprietà"} defaultExpanded={false}>
            {Propieta && <DynamicTable name={"Propieta"} dataset={Propieta} />}
          </AccordionSection>
        </CardContent>
      </Card>

      <Card>
        <CardContent
          sx={{
            maxWidth: isMobile ? "calc(100vw - 40px)" : "100%",
            overflowX: "auto",
          }}
        >
          <AccordionSection title={"Coperture"} defaultExpanded={false}>
            {Coperture && (
              <DynamicTable name={"Coperture"} dataset={Coperture} />
            )}
          </AccordionSection>
        </CardContent>
      </Card>
    </Box>
  );
}

export default Veicolo;
